<div *ngIf="response | async as r">
  <ng-template ngFor [ngForOf]="r.results" let-item>
    <div class="panel panel-default">
      <div class="panel-heading">
        <!-- todo: fix labeling -->
        <!--      {{ item.relationship_type | display:r.meta.fields.relationship_type.choices }} Information-->
        {{ r.meta.verbose_name }}
      </div>
      <div class="panel-body">
        <div class="col-md-6"
             *ngFor="let key of _displayFields(item)">

          <b><span [innerHtml]="r.meta.fields[key].label"></span></b>:
          <app-display-field [value]="item[key]" [getChoices]="r.meta.fields[key].get_choices"
                             [type]="r.meta.fields[key].type" [allowLong]="true"
                             [choices]="r.meta.fields[key].choices"></app-display-field>
          <br/>
        </div>
        <ng-container *ngFor="let subItem of subItems">
          <app-attachments *ngIf="subItem.indexOf('attachments') > -1" [foreignKey]="item.globalid" [type]="r.meta[subItem].type">
          </app-attachments>
          <app-nested-inline *ngIf="subItem.indexOf('attachments') === -1 && subItem.indexOf('review') < 0
                                                && item.globalid !== undefined && subItem.indexOf('payment') < 0 &&
                                                 subItem.indexOf('locations') < 0"
                             [meta]="r.meta[subItem]" [parentItem]="item"
                             [foreignKey]="item.globalid"></app-nested-inline>
        </ng-container>

      </div>
    </div>
    <app-summary-panel *ngFor="let i of relatedItems" [searchObject]="getSearchObject(i, item.globalid)"
                       [meta]="r.meta[i]"></app-summary-panel>
  </ng-template>
</div>
